import { useCallback, useContext, useEffect, useState } from 'react';

import * as EmpresaAPI from '../../../api/empresa';
import * as FiscalPerfilAPI from '../../../api/fiscalPerfil';
import { Context } from '../../../context/UserContext';
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import useFlashMessage from '../../../hooks/useFlashMessage';
import styles from '../../form/Form.module.css';

import Form from './Form';

function criarEstadoInicial(empresaId) {
    return {
        empresaId: Number(empresaId) || '',
        codigo: '',
        descricao: '',
        ativo: true,
        origemCadastro: 'MANUAL',
        revisaoPendente: false,
        integracaoAtivo: false,
        integracaoTodasEmpresas: false,
        observacao: '',
        versao: 1,
        Regras: [],
        produtosVinculados: 0,
    };
}

function CreateOrEdit() {
    const { parametro } = useContext(Context);
    const { empresaId, empresaIds } = getEmpresaScope();
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const urlParams = new URLSearchParams(window.location.search);
    const uuid = urlParams.get('uuid');
    const editando = Boolean(uuid && uuid !== 'null');

    const [token] = useState(localStorage.getItem('token') || '');

    const [dados, setDados] = useState(() => criarEstadoInicial(empresaId));

    const [optionsEmpresa, setOptionsEmpresa] = useState([]);
    const [carregando, setCarregando] = useState(editando);
    const [falhaCarregamento, setFalhaCarregamento] = useState(false);

    const carregarPerfil = useCallback(async () => {
        if (!editando || !uuid) return null;

        setCarregando(true);
        setFalhaCarregamento(false);

        try {
            const response = await FiscalPerfilAPI.consultar(uuid);

            const perfil = response.data.data;

            setDados((anterior) => ({
                ...anterior,
                ...perfil,
                empresaId: Number(perfil.empresaId),
                Regras: Array.isArray(perfil.Regras) ? perfil.Regras : [],
                produtosVinculados: Number(perfil.produtosVinculados) || 0,
            }));

            return perfil;
        } catch (error) {
            setFalhaCarregamento(true);

            setFlashMessage(
                error.response?.data?.message || 'Não foi possível carregar o perfil fiscal.',
                error.response?.data?.type || 'error'
            );

            return null;
        } finally {
            setCarregando(false);
        }
    }, [editando, setFlashMessage, uuid]);

    const consultaEmpresa = useCallback(async () => {
        const result = await EmpresaAPI.empresa();
        setOptionsEmpresa(result);
        return result;
    }, [empresaId]);

    //consulta Empresa
    useEffect(() => {
        consultaEmpresa();
    }, []);
    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
            return;
        }
    }, [token]);

    useEffect(() => {
        carregarPerfil();
    }, [carregarPerfil]);

    async function salvarPerfil(novosDados) {
        const payload = {
            empresaId: Number(novosDados.empresaId),
            codigo: String(novosDados.codigo || '')
                .trim()
                .toUpperCase(),
            descricao: String(novosDados.descricao || '').trim(),
            ativo: Boolean(novosDados.ativo),
            origemCadastro: novosDados.origemCadastro || 'MANUAL',
            revisaoPendente: Boolean(novosDados.revisaoPendente),
            integracaoAtivo: Boolean(novosDados.integracaoAtivo),
            integracaoTodasEmpresas: Boolean(novosDados.integracaoTodasEmpresas),
            observacao: String(novosDados.observacao || '').trim() || null,
        };

        try {
            const response = editando ? await FiscalPerfilAPI.editar(uuid, payload) : await FiscalPerfilAPI.cadastrar(payload);

            setFlashMessage(response.data.message, response.data.type);

            const sucesso = response.status >= 200 && response.status < 300 && response.data?.type === 'success';

            if (!sucesso) {
                return;
            }

            const params = new URLSearchParams(urlParams);

            params.delete('uuid');
            params.delete('btnText');

            navigate('/FiscalPerfis', params);
        } catch (error) {
            setFlashMessage(
                error.response?.data?.message || error.message || 'Não foi possível salvar o perfil fiscal.',
                error.response?.data?.type || 'error'
            );
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                dados={dados}
                setDados={setDados}
                handleSubmit={salvarPerfil}
                caminhoVoltar="/FiscalPerfis"
                OptionsEmpresa={optionsEmpresa}
                editando={editando}
                carregando={carregando}
                falhaCarregamento={falhaCarregamento}
                perfilUuid={uuid}
                recarregarPerfil={carregarPerfil}
            />
        </section>
    );
}

export default CreateOrEdit;
